import { render, staticRenderFns } from "./AdvisorsSelectbox.vue?vue&type=template&id=3310f96c&"
import script from "./AdvisorsSelectbox.vue?vue&type=script&lang=js&"
export * from "./AdvisorsSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports